// Hooks
import { useAppSelector } from "app/hooks";

// Store
import { getProjectCompanyData } from "store/slice/Project/projectData/ProjectSlice";

// Mui Components
import { Grid } from "@mui/material";

// Components
import { CompanySummaryHeader, CompanySummaryBody } from "components/CompanySummary";

const CompanySummary = ({ middlePlaceholder }: { middlePlaceholder?: JSX.Element | boolean }) => {
    const { data: company } = useAppSelector(getProjectCompanyData);

    return (
        <Grid container>
            <Grid item xs={middlePlaceholder ? 4 : 12}>
                <CompanySummaryHeader showAvatar title={company?.name ?? ""} />
                <CompanySummaryBody companyData={company} />
            </Grid>
            {middlePlaceholder && (
                <Grid item xs={4}>
                    {middlePlaceholder}
                </Grid>
            )}
        </Grid>
    );
};

export default CompanySummary;
